import React, {useEffect, useMemo, useRef, useState} from "react";
import style from "./VpnCard.module.css";
import {FirstBlockCard} from "./HeaderCard/FirstBlockCard";
import {Payments} from "../../Payments/Payments";
import PaymentStore from "../../../store/paymnet-store";
import {observer} from "mobx-react-lite";
import PaymnetStore from "../../../store/paymnet-store";
import {TelegramPayment} from "../../../Hooks/Api/Payments/useTelegramInvoice";
import UserStore from "../../../store/user-store";
import {getLavaTopInvoice} from "../../../Hooks/Api/Payments/rusCardsLavaTop";
import {IosLoader} from "../../Loaders/IosLaoder/IosLoader";
import {EmailInput} from "../../Payments/EmailInput/EmailInput";
import {PayPalSvg, StarkSvg} from "../../Icons/svg/paymnetSvgs";
import {cryptomusCreateInvoice} from "../../../Hooks/Api/Payments/cryptomusCreateInvoice";
import {motion, AnimatePresence} from "framer-motion";
import {SliderBtn} from "../../ui/Slider/SliderBtn";


const PERSONAL_PLAN_FEATURES_RU = [
    ["/images/plans_icons/traffic.svg", "Трафик", "10 TB в месяц", '300 GB на каждый регион'],
    ["/images/plans_icons/device.svg", "Устройства", "2 устройства", "Возможность использовать VPN на 2 устройствах одновременно"],
    ["/images/plans_icons/bolt.svg", "Скорость", "безлимитная"],
    [
        "/images/plans_icons/protocols.svg",
        "VPN протоколы",
        "Vless, Wireguard",
    ],
    ["/images/plans_icons/web.svg", "80 серверов", "35 регионов по всему миру"],
    ["/images/plans_icons/support.svg", "Поддержка", "24/7"],
];

const PERSONAL_PLAN_FEATURES_EN = [
    ["/images/plans_icons/traffic.svg", "Traffic", "10 TB per month", '300 GB per region'],
    ["/images/plans_icons/device.svg", "Devices", "2 devices", "Use VPN on 2 devices simultaneously"],
    ["/images/plans_icons/bolt.svg", "Speed", "unlimited"],
    [
        "/images/plans_icons/protocols.svg",
        "VPN protocols",
        "Vless, Wireguard",
    ],
    ["/images/plans_icons/web.svg", "80 servers", "35 regions worldwide"],
    ["/images/plans_icons/support.svg", "Support", "24/7"],
];

const FAMILY_PLAN_FEATURES_RU = [
    ["/images/plans_icons/traffic.svg", "Трафик", "Безлимитный", 'Безлимитный трафик'],
    ["/images/plans_icons/device.svg", "Устройства", "7 устройств", "Возможность использовать VPN на 7 устройствах одновременно"],
    ["/images/plans_icons/pro_mode.svg", "PRO режим", "гибкие настройки VPN протоклов", "гибкая настройка транспорта (TCP, gRPC, mKCP) для максимальной скорости, надёжности и обхода блокировок."],
    ["/images/plans_icons/bolt.svg", "Скорость", "безлимитная"],
    ["/images/plans_icons/protocols.svg", "VPN протоколы", "Vless, Wireguard, Shadowsocks, Trojan", "Shadowsocks, Trojan – появеться в ближайшем обновлении"],
    ["/images/plans_icons/web.svg", "100 серверов", "35 регионов по всему миру"],
    ["/images/plans_icons/support.svg", "Поддержка", "24/7"],
];
const FAMILY_PLAN_FEATURES_EN = [
    ["/images/plans_icons/traffic.svg", "Traffic", "Unlimited", 'Unlimited traffic'],
    ["/images/plans_icons/device.svg", "Devices", "7 devices", "Use VPN on 7 devices simultaneously"],
    ["/images/plans_icons/bolt.svg", "Speed", "unlimited"],
    [
        "/images/plans_icons/protocols.svg",
        "VPN protocols",
        "Vless, Wireguard, Shadowsocks, Trojan",
    ],
    ["/images/plans_icons/web.svg", "100 servers", "35 regions worldwide"],
    ["/images/plans_icons/support.svg", "Support", "24/7"],
];
const BUSINESS_PLAN_FEATURES_RU = [
    ["/images/plans_icons/traffic.svg", "Трафик", "Безлимитный", 'Безлимитный трафик'],
    ["/images/plans_icons/device.svg", "Устройства", "50 устройств", "Возможность использовать VPN на 50 устройствах одновременно"],
    ["/images/plans_icons/pro_mode.svg", "PRO режим", "гибкие настройки VPN протоклов", "гибкая настройка транспорта (TCP, gRPC, mKCP) для максимальной скорости, надёжности и обхода блокировок."],
    ["/images/plans_icons/vip.svg", "Выдедленные сервера", "ваши персональные сервера", "Отилчно подходят для торговли на бирже"],
    ["/images/plans_icons/protocols.svg", "VPN протоколы", "Vless, Wireguard, Shadowsocks, Trojan"],
    ["/images/plans_icons/web.svg", "200 серверов", "35 регионов по всему миру"],
    ["/images/plans_icons/support.svg", "Песорнальная поддержка", "24/7"],
];
const BUSINESS_PLAN_FEATURES_EN = [
    ["/images/plans_icons/traffic.svg", "Traffic", "Unlimited", 'Unlimited traffic'],
    ["/images/plans_icons/device.svg", "Devices", "50 devices", "Use VPN on 50 devices simultaneously"],
    ["/images/plans_icons/pro_mode.svg", "PRO mode", "Flexible settings of VPN protocols", "Flexible transport settings (TCP, gRPC, mKCP) for maximum speed, reliability and bypassing blocks."],
    ["/images/plans_icons/vip.svg", "Dedicated servers", "your personal servers", "Great for trading on the exchange"],
    ["/images/plans_icons/protocols.svg", "VPN protocols", "Vless, Wireguard, Shadowsocks, Trojan"],
    ["/images/plans_icons/web.svg", "200 servers", "35 regions worldwide"],
    ["/images/plans_icons/support.svg", "Personal support", "24/7"],
]

export const BuyPlan = observer(() => {
    const [index, setIndex] = useState(0);
    const [configurationIndex, setConfigurationIndex] = useState(0);
    const [activeTooltip, setActiveTooltip] = useState(null);
    const [isHiding, setIsHiding] = useState(false);
    const lang_code = UserStore.langCode;
    const tooltipRef = useRef(null);
    const [paymentsMethods, setPaymentsMethods] = useState([]);


    const paymentMethodHandler = () => {
        PaymnetStore.setPlanId(plan_data[index]?.plan_id);
        if (PaymnetStore.paymentMethod === 4) {
            TelegramPayment(plan_data[index]?.plan_id, lang_code, configurationIndex + 1);
        } else if ([1, 2, 5].includes(PaymnetStore.paymentMethod)) {
            getLavaTopInvoice(
                plan_data[index]?.plan_id,
                configurationIndex + 1,
                PaymnetStore.paymentMethod,
                lang_code
            );
        } else if (PaymnetStore.paymentMethod === 3) {
            cryptomusCreateInvoice(plan_data[index]?.plan_id, configurationIndex + 1,);
        }
    };

    const hapticFeedBack = () => {
        window.Telegram.WebApp.HapticFeedback.notificationOccurred("success");
    };

    const PLAN_NAMES = [
        {text: lang_code === "ru" ? "Месячный" : "Monthly", id: 0},
        {text: lang_code === "ru" ? "Годовой" : "Annual", id: 1},
        // {text: lang_code === "ru" ? "Навсегда" : "Lifetime", id: 2},
    ];

    const PLAN_CONFIGURATION = [
        {
            id: 0,
            name: lang_code === "ru" ? "Личный" : "Personal",
            icon: (
                <svg
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <mask
                        id="mask0_1285_31356"
                        maskUnits="userSpaceOnUse"
                        x="1"
                        y="0"
                        width="15"
                        height="15"
                    >
                        <path
                            d="M8.83309 5.99992C10.1218 5.99992 11.1664 4.95525 11.1664 3.66659C11.1664 2.37792 10.1218 1.33325 8.83309 1.33325C7.54442 1.33325 6.49976 2.37792 6.49976 3.66659C6.49976 4.95525 7.54442 5.99992 8.83309 5.99992Z"
                            fill="#555555"
                            stroke="white"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M2.1665 13.6666C2.1665 10.7209 4.85284 8.33325 8.1665 8.33325"
                            stroke="white"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M11.4498 9.33325C10.7412 9.33325 10.1665 10.0029 10.1665 10.8286C10.1665 12.3243 11.6832 13.6836 12.4998 13.9999C13.3165 13.6836 14.8332 12.3243 14.8332 10.8286C14.8332 10.0033 14.2585 9.33325 13.5498 9.33325C13.1158 9.33325 12.7322 9.58425 12.4998 9.96859C12.2675 9.58425 11.8838 9.33325 11.4498 9.33325Z"
                            fill="#555555"
                            stroke="white"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </mask>
                    <g mask="url(#mask0_1285_31356)">
                        <path d="M0.833252 0H16.8333V16H0.833252V0Z" fill="gray"/>
                    </g>
                </svg>
            ),
        },
        {
            id: 1,
            name: lang_code === "ru" ? "Семейный" : "Family",
            icon: (
                <svg
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <mask
                        id="mask0_1285_31284"
                        maskUnits="userSpaceOnUse"
                        x="1"
                        y="2"
                        width="15"
                        height="12"
                    >
                        <path
                            d="M3.8335 6.3335C3.8335 6.3335 2.11916 7.00016 1.8335 9.3335M13.1668 6.3335C13.1668 6.3335 14.8812 7.00016 15.1668 9.3335M6.50016 6.3335C6.50016 6.3335 8.10016 6.7225 8.50016 8.66683C8.90016 6.7225 10.5002 6.3335 10.5002 6.3335M7.16683 11.3335C7.16683 11.3335 5.76683 11.5835 5.16683 13.3335M9.8335 11.3335C9.8335 11.3335 11.2335 11.5835 11.8335 13.3335"
                            stroke="white"
                            strokeLinecap="round"
                        />
                        <path
                            d="M8.50016 12.0001C9.42064 12.0001 10.1668 11.2539 10.1668 10.3334C10.1668 9.41294 9.42064 8.66675 8.50016 8.66675C7.57969 8.66675 6.8335 9.41294 6.8335 10.3334C6.8335 11.2539 7.57969 12.0001 8.50016 12.0001Z"
                            fill="#555555"
                            stroke="white"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M11.8335 6.66675C12.9381 6.66675 13.8335 5.77132 13.8335 4.66675C13.8335 3.56218 12.9381 2.66675 11.8335 2.66675C10.7289 2.66675 9.8335 3.56218 9.8335 4.66675C9.8335 5.77132 10.7289 6.66675 11.8335 6.66675Z"
                            fill="#555555"
                            stroke="white"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M5.16699 6.66675C6.27156 6.66675 7.16699 5.77132 7.16699 4.66675C7.16699 3.56218 6.27156 2.66675 5.16699 2.66675C4.06242 2.66675 3.16699 3.56218 3.16699 4.66675C3.16699 5.77132 4.06242 6.66675 5.16699 6.66675Z"
                            fill="#555555"
                            stroke="white"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </mask>
                    <g mask="url(#mask0_1285_31284)">
                        <path d="M0.5 0H16.5V16H0.5V0Z" fill="gray"/>
                    </g>
                </svg>
            ),
        },
        {
            id: 2,
            name: lang_code === "ru" ? "Бизнес" : "Business",
            icon: (
                <svg
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g opacity="0.5">
                        <path
                            opacity="0.3"
                            d="M10.6668 11.3333H6.66683V10.6667H4.00016V12.6667H13.3335V10.6667H10.6668V11.3333ZM3.3335 9.33333H6.66683V7.33333H10.6668V9.33333H14.0002V6H3.3335V9.33333Z"
                            fill="gray"
                        />
                        <path
                            d="M14.0005 4.66667H11.3338V3.33333L10.0005 2H7.33382L6.00049 3.33333V4.66667H3.33382C2.60049 4.66667 2.00049 5.26667 2.00049 6V9.33333C2.00049 9.83333 2.26715 10.2533 2.66715 10.4867V12.6667C2.66715 13.4067 3.26049 14 4.00049 14H13.3338C14.0738 14 14.6672 13.4067 14.6672 12.6667V10.48C15.0605 10.2467 15.3338 9.82 15.3338 9.33333V6C15.3338 5.26667 14.7338 4.66667 14.0005 4.66667ZM7.33382 3.33333H10.0005V4.66667H7.33382V3.33333ZM13.3338 12.6667H4.00049V10.6667H6.66715V11.3333H10.6672V10.6667H13.3338V12.6667ZM8.00049 10V8.66667H9.33382V10H8.00049ZM14.0005 9.33333H10.6672V7.33333H6.66715V9.33333H3.33382V6H14.0005V9.33333Z"
                            fill="gray"
                        />
                    </g>
                </svg>
            ),
        },
    ];


    const PERSONAL_PLAN_FEATURES = lang_code === "ru" ? PERSONAL_PLAN_FEATURES_RU : PERSONAL_PLAN_FEATURES_EN;


    const FAMILY_PLAN_FEATURES = lang_code === "ru" ? FAMILY_PLAN_FEATURES_RU : FAMILY_PLAN_FEATURES_EN;


    const BUSINESS_PLAN_FEATURES = lang_code === "ru" ? BUSINESS_PLAN_FEATURES_RU : BUSINESS_PLAN_FEATURES_EN;


    const plan_data = useMemo(() => {
        return [
            {
                img_src: "/images/plan_cards/Monthly.png",
                plan_name: lang_code === "ru" ? "Месячный план" : "Monthly plan",
                plan_prices: [
                    {
                        rub_base_price: 507,
                        rub_sale_price: 434,
                        usd_base_price: 6.54,
                        usd_sale_price: 5.43,
                        stars: 250,
                        sale_amount: 17
                    },
                    {
                        rub_base_price: 825,
                        rub_sale_price: 750,
                        usd_base_price: 10,
                        usd_sale_price: 9,
                        stars: 350,
                        sale_amount: 10
                    },
                    {
                        rub_base_price: 2300,
                        rub_sale_price: 4040,
                        usd_base_price: 29,
                        usd_sale_price: 0,
                        stars: 900,
                        sale_amount: 0
                    },
                ],
                plan_id: 1,
                plan_features: [
                    PERSONAL_PLAN_FEATURES,
                    FAMILY_PLAN_FEATURES,
                    BUSINESS_PLAN_FEATURES,
                ],
            },
            {
                img_src: "/images/plan_cards/Annual.png",
                sale_amount: 0,
                plan_name: lang_code === "ru" ? "Годовой план" : "Annual plan",
                plan_prices: [
                    {
                        rub_base_price: 3570,
                        rub_sale_price: 0,
                        usd_base_price: 44.9,
                        usd_sale_price: 0,
                        stars: 1250,
                        sale_amount: 0
                    },
                    {
                        rub_base_price: 6200,
                        rub_sale_price: 0,
                        usd_base_price: 79,
                        usd_sale_price: 0,
                        stars: 2150,
                        sale_amount: 0
                    },
                    {
                        rub_base_price: 19220,
                        rub_sale_price: 0,
                        usd_base_price: 250,
                        usd_sale_price: 0,
                        stars: 8000,
                        sale_amount: 0
                    },
                ],
                plan_id: 3,
                plan_features: [
                    PERSONAL_PLAN_FEATURES,
                    FAMILY_PLAN_FEATURES,
                    BUSINESS_PLAN_FEATURES,
                ]
            },
            {
                img_src: "/images/plan_cards/Pass.png",
                plan_name: "Lifetime private pass",
                plan_prices: [
                    {
                        rub_base_price: 9900,
                        rub_sale_price: 8999,
                        usd_base_price: 6,
                        usd_sale_price: 5,
                        stars: 350,
                        sale_amount: 10
                    },
                    {
                        rub_base_price: 690,
                        rub_sale_price: 500,
                        usd_base_price: 12,
                        usd_sale_price: 9,
                        stars: 600,
                        sale_amount: 10
                    },
                    {
                        rub_base_price: 1200,
                        rub_sale_price: 500,
                        usd_base_price: 12,
                        usd_sale_price: 9,
                        stars: 1000,
                        sale_amount: 10
                    },
                ],
                plan_id: 6,
                plan_features:
                    [
                        PERSONAL_PLAN_FEATURES,
                        FAMILY_PLAN_FEATURES,
                        BUSINESS_PLAN_FEATURES,
                    ]
            },
        ];
    }, [lang_code]);


    const regionCodes = ["AM", "AZ", "BY", "KZ", "KG", "MD", "RU", "TJ", "UZ"];
    const hasSale = plan_data[index].plan_prices[configurationIndex]?.sale_amount > 0;
    const saleAmount = plan_data[index].plan_prices[configurationIndex]?.sale_amount
    useEffect(() => {
        const DEF_METHODS = [
            {
                id: 2,
                is_img: false,
                logo: (
                    <svg
                        width="40"
                        height="40"
                        viewBox="0 0 40 40"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M20 40C31.0457 40 40 31.0457 40 20C40 8.95429 31.0457 0 20 0C8.95429 0 0 8.95429 0 20C0 31.0457 8.95429 40 20 40Z"
                            fill="white"
                        />
                        <g clipPath="url(#clip0_1428_39705)">
                            <path
                                d="M22.7155 14.5352H16.4434V25.8037H22.7155V14.5352Z"
                                fill="#FF5A00"
                            />
                            <path
                                d="M16.8608 20.1675C16.8608 17.8781 17.9371 15.8461 19.5887 14.5332C18.3732 13.5776 16.8399 13 15.1675 13C11.2057 13 8 16.2057 8 20.1675C8 24.1294 11.2057 27.3351 15.1675 27.3351C16.8399 27.3351 18.3732 26.7575 19.5887 25.8018C17.9348 24.5075 16.8608 22.457 16.8608 20.1675Z"
                                fill="#EB001B"
                            />
                            <path
                                d="M31.1785 20.1675C31.1785 24.1294 27.9728 27.3351 24.011 27.3351C22.3386 27.3351 20.8053 26.7575 19.5898 25.8018C21.2623 24.4866 22.3177 22.457 22.3177 20.1675C22.3177 17.8781 21.2414 15.8461 19.5898 14.5332C20.803 13.5776 22.3362 13 24.0087 13C27.9728 13 31.1785 16.2265 31.1785 20.1675Z"
                                fill="#F79E1B"
                            />
                        </g>
                        <defs>
                            <clipPath id="clip0_1428_39705">
                                <rect
                                    width="23.1773"
                                    height="18"
                                    fill="white"
                                    transform="translate(8 11)"
                                />
                            </clipPath>
                        </defs>
                    </svg>
                ),
                name: lang_code === "ru" ? "Иностранная карта" : "international card",
                saleAmount: saleAmount,
                amount: plan_data[index].plan_prices[configurationIndex][hasSale ? "usd_sale_price" : "usd_base_price"],
                currency: " $",
                isSoon: false,
            },
            {
                id: 3,
                is_img: false,
                logo: (
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="40"
                        height="40"
                        viewBox="0 0 40 40"
                        fill="none"
                    >
                        <g clipPath="url(#clip0_0_8825)">
                            <path
                                d="M20 40C31.0457 40 40 31.0457 40 20C40 8.95429 31.0457 0 20 0C8.95429 0 0 8.95429 0 20C0 31.0457 8.95429 40 20 40Z"
                                fill="white"
                            />
                            <g clipPath="url(#clip1_0_8825)">
                                <path
                                    d="M27.1743 18.6552C30.3928 18.6552 33.0019 16.0461 33.0019 12.8276C33.0019 9.6091 30.3928 7 27.1743 7C23.9558 7 21.3467 9.6091 21.3467 12.8276C21.3467 16.0461 23.9558 18.6552 27.1743 18.6552Z"
                                    fill="#0098EA"
                                />
                                <path
                                    d="M29.1605 10.2528H25.1807C24.449 10.2528 23.9852 11.0421 24.3533 11.6802L26.8095 15.9375C26.9698 16.2154 27.3715 16.2154 27.5317 15.9375L29.9884 11.6802C30.356 11.0432 29.8922 10.2528 29.161 10.2528H29.1605ZM26.8075 14.6608L26.2726 13.6255L24.9819 11.3171C24.8968 11.1694 25.0019 10.98 25.1802 10.98H26.807V14.6613L26.8075 14.6608ZM29.3583 11.3166L28.0681 13.626L27.5332 14.6608V10.9795H29.16C29.3383 10.9795 29.4435 11.1689 29.3583 11.3166Z"
                                    fill="white"
                                />
                            </g>
                            <path
                                d="M18.6236 27.1724C18.6236 30.374 16.0283 32.9693 12.8268 32.9693C9.62525 32.9693 7.02991 30.374 7.02991 27.1724C7.02991 23.9709 9.62525 21.3755 12.8268 21.3755C16.0283 21.3755 18.6236 23.9709 18.6236 27.1724Z"
                                fill="#505050"
                            />
                            <g opacity="0.8">
                                <path
                                    d="M12.8083 24.4827L12.7725 24.6044V28.1358L12.8083 28.1715L14.4475 27.2026L12.8083 24.4827Z"
                                    fill="white"
                                />
                                <path
                                    d="M12.8082 24.4827L11.1689 27.2026L12.8082 28.1716V26.4575V24.4827Z"
                                    fill="white"
                                />
                                <path
                                    d="M12.8083 28.7049L12.7881 28.7295V29.9875L12.8083 30.0464L14.4485 27.7365L12.8083 28.7049Z"
                                    fill="white"
                                />
                                <path
                                    d="M12.8082 30.0464V28.7049L11.1689 27.7365L12.8082 30.0464Z"
                                    fill="white"
                                />
                                <path
                                    d="M12.8082 28.1715L14.4475 27.2026L12.8082 26.4575V28.1715Z"
                                    fill="white"
                                />
                                <path
                                    d="M11.1689 27.2026L12.8082 28.1716V26.4575L11.1689 27.2026Z"
                                    fill="white"
                                />
                            </g>
                            <g clipPath="url(#clip2_0_8825)">
                                <path
                                    d="M32.66 26.83C32.66 27.9831 32.3181 29.1102 31.6775 30.069C31.0369 31.0277 30.1263 31.775 29.061 32.2162C27.9958 32.6575 26.8235 32.7729 25.6926 32.548C24.5617 32.323 23.5229 31.7678 22.7076 30.9524C21.8922 30.1371 21.337 29.0983 21.112 27.9674C20.8871 26.8365 21.0025 25.6642 21.4438 24.599C21.885 23.5337 22.6323 22.6231 23.591 21.9825C24.5498 21.3419 25.6769 21 26.83 21C28.3762 21 29.8591 21.6142 30.9524 22.7076C32.0458 23.8009 32.66 25.2838 32.66 26.83Z"
                                    fill="#F7931A"
                                />
                                <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M25.1436 23.6622L26.4834 24.021L26.7829 22.9048L27.4528 23.0866L27.165 24.1567L27.7114 24.3035L27.9997 23.2218L28.6813 23.4041L28.3877 24.4917C28.3877 24.4917 29.5007 24.7381 29.7625 25.6434C30.0243 26.5486 29.1869 27.024 28.9283 27.042C28.9283 27.042 29.9035 27.5768 29.5685 28.6288C29.2336 29.6809 28.2054 29.869 27.1237 29.6279L26.83 30.7557L26.1485 30.5734L26.4479 29.4631L25.9073 29.3157L25.6079 30.434L24.9316 30.2522L25.2316 29.1392L23.8562 28.7682L24.2028 27.9987C24.2028 27.9987 24.5908 28.1047 24.7376 28.1397C24.8844 28.1746 24.9787 28.022 25.0201 27.8694C25.0614 27.7167 25.6842 25.187 25.743 24.9787C25.8018 24.7704 25.778 24.6077 25.531 24.5436C25.284 24.4795 24.948 24.3793 24.948 24.3793L25.1436 23.6622ZM26.4951 27.0123L26.1241 28.4873C26.1241 28.4873 27.9637 29.1514 28.199 28.217C28.4343 27.2826 26.4951 27.0123 26.4951 27.0123ZM26.6657 26.3127L27.0298 24.9612C27.0298 24.9612 28.605 25.2432 28.411 25.9953C28.217 26.7473 27.2885 26.459 26.6657 26.3127Z"
                                    fill="white"
                                />
                            </g>
                            <g clipPath="url(#clip3_0_8825)">
                                <path
                                    d="M12.83 18.66C16.0498 18.66 18.66 16.0498 18.66 12.83C18.66 9.61018 16.0498 7 12.83 7C9.61018 7 7 9.61018 7 12.83C7 16.0498 9.61018 18.66 12.83 18.66Z"
                                    fill="#26A17B"
                                />
                                <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M13.5303 13.3341V13.3333C13.4902 13.3363 13.2836 13.3486 12.8227 13.3486C12.4547 13.3486 12.1956 13.3377 12.1045 13.3333V13.3344C10.6878 13.2721 9.63039 13.0254 9.63039 12.7303C9.63039 12.4355 10.6878 12.1888 12.1045 12.1254V13.0888C12.1971 13.0954 12.4623 13.1111 12.8289 13.1111C13.2687 13.1111 13.4891 13.0928 13.5303 13.0892V12.1262C14.9441 12.1892 15.9989 12.4359 15.9989 12.7303C15.9989 13.0254 14.9441 13.2714 13.5303 13.3341ZM13.5303 12.026V11.1638H15.503V9.84918H10.1318V11.1638H12.1045V12.0256C10.5012 12.0992 9.29553 12.4169 9.29553 12.7973C9.29553 13.1777 10.5012 13.4951 12.1045 13.5691V16.3318H13.5303V13.5684C15.131 13.4948 16.3338 13.1774 16.3338 12.7973C16.3338 12.4173 15.131 12.0999 13.5303 12.026Z"
                                    fill="white"
                                />
                            </g>
                        </g>
                        <defs>
                            <clipPath id="clip0_0_8825">
                                <rect width="40" height="40" fill="white"/>
                            </clipPath>
                            <clipPath id="clip1_0_8825">
                                <rect
                                    width="11.6552"
                                    height="11.6552"
                                    fill="white"
                                    transform="translate(21.3477 7)"
                                />
                            </clipPath>
                            <clipPath id="clip2_0_8825">
                                <rect
                                    width="11.66"
                                    height="11.66"
                                    fill="white"
                                    transform="translate(21 21)"
                                />
                            </clipPath>
                            <clipPath id="clip3_0_8825">
                                <rect
                                    width="11.66"
                                    height="11.66"
                                    fill="white"
                                    transform="translate(7 7)"
                                />
                            </clipPath>
                        </defs>
                    </svg>
                ),
                name: "Any crypto",
                saleAmount: saleAmount,
                amount: plan_data[index].plan_prices[configurationIndex][hasSale ? "usd_sale_price" : "usd_base_price"],
                currency: " $",
                isSoon: false,
            },
            {
                id: 4,
                is_img: false,
                logo: (
                    <svg
                        width="40"
                        height="40"
                        viewBox="0 0 40 40"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
                            fill="#FBC01C"
                        />
                        <g clipPath="url(#clip0_1121_1375)">
                            <path
                                d="M19.7598 10.1099C19.9454 10.0963 20.1238 10.1005 20.3016 10.1614C20.3284 10.1705 20.3547 10.1807 20.3807 10.1918C20.4066 10.203 20.4321 10.2151 20.4571 10.2283C20.4822 10.2414 20.5067 10.2555 20.5306 10.2705C20.5545 10.2855 20.5779 10.3014 20.6006 10.3182C20.6233 10.335 20.6453 10.3526 20.6667 10.3711C20.6881 10.3896 20.7087 10.4089 20.7286 10.429C20.7485 10.4491 20.7676 10.4699 20.7859 10.4914C20.8041 10.513 20.8216 10.5352 20.8381 10.5581C20.9691 10.7371 21.0592 10.9501 21.1559 11.1489L21.556 11.9679L23.1532 15.2065C23.2824 15.4654 23.4471 15.7375 23.7099 15.8819C23.829 15.9474 23.9648 15.991 24.0975 16.0186C24.5223 16.1074 24.9826 16.1335 25.4144 16.1863L28.0458 16.5065C28.4143 16.5507 28.8368 16.5567 29.1876 16.6772C29.2058 16.6835 29.2238 16.6903 29.2416 16.6975C29.2595 16.7047 29.2771 16.7124 29.2946 16.7205C29.3121 16.7286 29.3293 16.7371 29.3464 16.746C29.3635 16.755 29.3803 16.7643 29.3969 16.7741C29.4135 16.7839 29.4298 16.794 29.4459 16.8046C29.462 16.8152 29.4778 16.8262 29.4934 16.8375C29.5089 16.8489 29.5242 16.8606 29.5392 16.8727C29.5542 16.8848 29.5688 16.8973 29.5832 16.9101C29.5976 16.923 29.6116 16.9361 29.6253 16.9496C29.639 16.9632 29.6524 16.977 29.6654 16.9912C29.6785 17.0054 29.6911 17.0199 29.7035 17.0347C29.7158 17.0495 29.7277 17.0646 29.7393 17.08C29.7509 17.0954 29.762 17.111 29.7728 17.127C29.7836 17.1429 29.794 17.1591 29.804 17.1756C29.8141 17.192 29.8237 17.2087 29.8328 17.2257C29.842 17.2426 29.8508 17.2597 29.8591 17.2771C30.0114 17.5903 30.0121 17.9903 29.8595 18.3028C29.8343 18.3551 29.8057 18.4055 29.7737 18.4539C29.7417 18.5024 29.7066 18.5484 29.6683 18.5921C29.347 18.9599 28.9629 19.2944 28.6139 19.6369L26.5683 21.6481C26.3194 21.893 25.9178 22.2243 25.7467 22.5218C25.683 22.6325 25.6799 22.7249 25.682 22.8497C25.6852 23.0322 25.7174 23.2165 25.7395 23.3975C25.7749 23.6953 25.8119 23.9929 25.8506 24.2902L26.1322 26.5478C26.2001 27.07 26.3963 28.0317 26.2332 28.4982C26.2258 28.5186 26.218 28.5387 26.2097 28.5587C26.2014 28.5787 26.1926 28.5984 26.1833 28.618C26.1741 28.6375 26.1643 28.6568 26.1541 28.6759C26.1439 28.6949 26.1333 28.7138 26.1221 28.7323C26.111 28.7508 26.0994 28.7691 26.0874 28.7871C26.0754 28.8051 26.063 28.8228 26.0501 28.8401C26.0372 28.8575 26.0239 28.8746 26.0102 28.8913C25.9965 28.908 25.9824 28.9244 25.9679 28.9405C25.9534 28.9565 25.9385 28.9722 25.9232 28.9875C25.9079 29.0028 25.8923 29.0178 25.8763 29.0323C25.8603 29.0469 25.844 29.061 25.8273 29.0748C25.8106 29.0885 25.7936 29.1019 25.7763 29.1148C25.7589 29.1278 25.7413 29.1403 25.7234 29.1523C25.7054 29.1644 25.6872 29.176 25.6687 29.1872C25.6502 29.1984 25.6314 29.2091 25.6124 29.2194C25.5933 29.2297 25.5741 29.2395 25.5545 29.2488C25.538 29.2566 25.5213 29.2641 25.5044 29.2711C25.4876 29.2782 25.4705 29.285 25.4534 29.2914C25.4363 29.2977 25.419 29.3037 25.4016 29.3094C25.3842 29.3151 25.3667 29.3204 25.3491 29.3253C25.3314 29.3302 25.3137 29.3348 25.2959 29.339C25.2781 29.3432 25.2602 29.347 25.2423 29.3504C25.2243 29.3538 25.2063 29.3569 25.1882 29.3596C25.1701 29.3623 25.1519 29.3646 25.1338 29.3665C25.1156 29.3685 25.0973 29.37 25.0791 29.3712C25.0608 29.3724 25.0426 29.3732 25.0243 29.3736C25.006 29.374 24.9877 29.3741 24.9694 29.3737C24.9511 29.3733 24.9328 29.3726 24.9146 29.3715C24.8963 29.3704 24.8781 29.3689 24.8599 29.367C24.8417 29.3652 24.8235 29.3629 24.8055 29.3603C24.7873 29.3577 24.7693 29.3547 24.7513 29.3513C24.7333 29.3479 24.7154 29.3441 24.6976 29.34C24.3392 29.255 23.9872 29.0077 23.6639 28.8319L21.3786 27.5999C21.0473 27.4201 20.5737 27.1142 20.2388 27.0006C20.0754 26.9451 19.8563 26.9286 19.6886 26.9758C19.3273 27.0773 18.6706 27.4626 18.3059 27.6498C17.2902 28.1713 16.2787 28.704 15.2572 29.2138C15.1861 29.2413 15.111 29.2671 15.0366 29.2836C15.0174 29.2879 14.998 29.2918 14.9786 29.2952C14.9591 29.2986 14.9396 29.3015 14.92 29.304C14.9004 29.3064 14.8808 29.3084 14.8611 29.3099C14.8414 29.3113 14.8217 29.3123 14.8019 29.3128C14.7822 29.3133 14.7625 29.3133 14.7427 29.3129C14.723 29.3124 14.7033 29.3114 14.6836 29.31C14.6639 29.3085 14.6442 29.3066 14.6246 29.3042C14.605 29.3018 14.5855 29.2989 14.566 29.2955C14.5466 29.2921 14.5272 29.2882 14.508 29.2839C14.4887 29.2796 14.4696 29.2748 14.4505 29.2695C14.4315 29.2642 14.4126 29.2585 14.3939 29.2522C14.3751 29.246 14.3566 29.2393 14.3382 29.2322C14.3197 29.2251 14.3015 29.2175 14.2835 29.2095C14.2655 29.2014 14.2476 29.193 14.23 29.1841C14.2124 29.1752 14.195 29.1658 14.1778 29.1561C14.1607 29.1463 14.1438 29.1361 14.1271 29.1255C14.1109 29.1153 14.0949 29.1048 14.0792 29.0938C14.0634 29.0828 14.048 29.0715 14.0329 29.0598C14.0178 29.048 14.0029 29.0359 13.9884 29.0234C13.9739 29.0109 13.9597 28.9981 13.9458 28.9849C13.9319 28.9717 13.9184 28.9581 13.9052 28.9442C13.892 28.9303 13.8792 28.9161 13.8667 28.9015C13.8542 28.887 13.8421 28.8722 13.8304 28.857C13.8187 28.8419 13.8073 28.8264 13.7964 28.8107C13.7854 28.795 13.7749 28.779 13.7648 28.7627C13.7546 28.7465 13.7449 28.73 13.7356 28.7132C13.7263 28.6965 13.7174 28.6795 13.709 28.6623C13.7005 28.6451 13.6925 28.6277 13.685 28.6101C13.6774 28.5925 13.6703 28.5747 13.6636 28.5568C13.6569 28.5388 13.6507 28.5207 13.645 28.5024C13.6392 28.4842 13.6339 28.4658 13.6291 28.4472C13.6243 28.4287 13.6199 28.41 13.616 28.3913C13.5305 27.9682 13.7325 26.9808 13.8 26.5167C13.8962 25.8561 13.9566 25.195 14.2641 24.5902C14.293 24.5322 14.3234 24.4751 14.3554 24.4188C14.3875 24.3625 14.4211 24.3072 14.4562 24.2528C14.4913 24.1984 14.5279 24.145 14.566 24.0926C14.6041 24.0402 14.6437 23.9889 14.6846 23.9388C14.7256 23.8886 14.7679 23.8396 14.8116 23.7918C14.8553 23.744 14.9003 23.6974 14.9465 23.6521C14.9928 23.6068 15.0403 23.5628 15.0891 23.5202C15.1378 23.4775 15.1877 23.4362 15.2387 23.3964C15.7351 23.006 16.4715 22.6925 17.0428 22.4029L19.6759 21.064C19.8622 20.9699 20.4302 20.7345 20.5217 20.5797C20.5507 20.5307 20.5532 20.466 20.5392 20.412C20.4624 20.1157 19.9904 20.2674 19.7756 20.2983L16.3354 20.7903C15.629 20.8919 14.723 21.2071 14.0307 21.1581C13.9735 21.1536 13.9165 21.1475 13.8596 21.1397C13.8027 21.132 13.7461 21.1226 13.6898 21.1115C13.6335 21.1005 13.5775 21.0879 13.5219 21.0737C13.4663 21.0595 13.4111 21.0437 13.3564 21.0263C13.3017 21.0089 13.2475 20.99 13.1939 20.9695C13.1403 20.9491 13.0873 20.9271 13.0349 20.9036C12.9825 20.8801 12.9309 20.8551 12.88 20.8286C12.829 20.8022 12.7789 20.7743 12.7295 20.745C12.2178 20.4473 11.6692 19.9399 11.1959 19.5571C10.9021 19.3195 10.4807 19.0285 10.2446 18.7509C10.1332 18.62 10.0551 18.4465 10.0132 18.2807C10.008 18.2608 10.0033 18.2407 9.99918 18.2205C9.99501 18.2002 9.99135 18.18 9.98821 18.1596C9.98506 18.1392 9.98242 18.1187 9.98029 18.0982C9.97816 18.0777 9.97654 18.0571 9.97543 18.0365C9.97433 18.0159 9.97374 17.9953 9.97364 17.9747C9.97356 17.954 9.97401 17.9334 9.97497 17.9128C9.97591 17.8922 9.97736 17.8716 9.97934 17.8511C9.98132 17.8305 9.9838 17.81 9.9868 17.7896C9.98977 17.7692 9.99326 17.7489 9.99728 17.7287C10.0013 17.7084 10.0058 17.6883 10.0108 17.6683C10.0158 17.6483 10.0213 17.6284 10.0273 17.6086C10.0333 17.5889 10.0398 17.5693 10.0468 17.5499C10.0537 17.5305 10.0612 17.5113 10.0691 17.4922C10.0771 17.4732 10.0854 17.4543 10.0943 17.4357C10.1032 17.4171 10.1125 17.3987 10.1223 17.3805C10.1321 17.3624 10.1423 17.3444 10.153 17.3268C10.2868 17.109 10.4924 16.921 10.7303 16.825C11.1251 16.6657 11.6179 16.6541 12.041 16.601L14.6626 16.1448C15.0652 16.0937 15.5065 16.081 15.8989 15.9842C16.092 15.9365 16.2789 15.8205 16.4021 15.6625C16.609 15.3972 16.8849 14.7516 17.0468 14.4295L18.3012 11.9518C18.5121 11.5341 18.72 11.0519 18.9619 10.659C19.1564 10.3432 19.4057 10.1942 19.7598 10.1099Z"
                                fill="white"
                            />
                        </g>
                        <defs>
                            <clipPath id="clip0_1121_1375">
                                <rect
                                    width="20"
                                    height="20"
                                    fill="white"
                                    transform="translate(10 10)"
                                />
                            </clipPath>
                        </defs>
                    </svg>
                ),
                name: "Telegram Stars",
                amount: plan_data[index].plan_prices[configurationIndex]["stars"],
                isSoon: false,
                currency: " ★",

            },
            {
                id: 5,
                is_img: false,
                logo: PayPalSvg,
                name: "PayPal",
                saleAmount: saleAmount,
                amount: plan_data[index].plan_prices[configurationIndex][hasSale ? "usd_sale_price" : "usd_base_price"],
                currency: " $",
                isSoon: false,
            },
            {
                id: 6,
                is_img: false,
                logo: StarkSvg,
                name: "STRK",
                amount: plan_data[index].plan_prices[configurationIndex][hasSale ? "usd_sale_price" : "usd_base_price"],
                currency: " $",
                isSoon: false,
            }
        ];
        const RUB_CARDS = {
            id: 1,
            is_img: false,
            logo: (
                <svg
                    width="40"
                    height="40"
                    viewBox="0 0 40 40"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <rect width="40" height="40" rx="20" fill="black"/>
                    <path
                        d="M15.9997 30.3346V11.668H23.9997C25.0605 11.668 26.078 12.0894 26.8281 12.8395C27.5782 13.5897 27.9997 14.6071 27.9997 15.668C27.9997 16.7288 27.5782 17.7463 26.8281 18.4964C26.078 19.2465 25.0605 19.668 23.9997 19.668H13.333"
                        stroke="white"
                        strokeWidth="2.66667"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M23.9997 25H13.333"
                        stroke="white"
                        strokeWidth="2.66667"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            ),
            name: lang_code === "ru" ? "Российская карта" : "Russian card",
            saleAmount: saleAmount,
            amount: plan_data[index].plan_prices[configurationIndex][hasSale ? "rub_sale_price" : "rub_base_price"],
            currency: " ₽",
            isSoon: false,
        };

        if (UserStore.countryCode && regionCodes.includes(UserStore.countryCode)) {
            setPaymentsMethods([RUB_CARDS, ...DEF_METHODS]);
        } else if (lang_code === "ru") {
            setPaymentsMethods([RUB_CARDS, ...DEF_METHODS]);
        } else {
            setPaymentsMethods([...DEF_METHODS]);
        }
    }, [lang_code, index, configurationIndex]);

    const handleTooltipClick = (index, el) => {
        if (el[3]) {
            if (activeTooltip === index) {
                setIsHiding(true);
                setTimeout(() => {
                    setActiveTooltip(null);
                    setIsHiding(false);
                }, 200);
            } else {
                setActiveTooltip(index);
            }
        }
    };

    useEffect(() => {
        if (activeTooltip !== null) {
            const handleClickOutside = (event) => {
                if (
                    tooltipRef.current &&
                    !tooltipRef.current.contains(event.target)
                ) {
                    setIsHiding(true);
                    setTimeout(() => {
                        setActiveTooltip(null);
                        setIsHiding(false);
                    }, 200);
                }
            };
            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }
    }, [activeTooltip]);

    if (!paymentsMethods) return <IosLoader/>;

    return (
        <>
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column",
                    width: "100%",
                    gap: "16px",
                }}
            >
                <div className={style.vpn_card__main}
                     style={PaymnetStore.isPaymentSelected ? {} : {height: "calc(100dvh - 72px - 60px - 16px - 16px - 20px)"}}>
                    <AnimatePresence mode="wait">
                        <motion.div
                            key={index}
                            initial={{opacity: 0, x: 20}}
                            animate={{opacity: 1, x: 0}}
                            exit={{opacity: 0, x: -20}}
                            transition={{duration: 0.2}}
                        >
                            <FirstBlockCard
                                props={plan_data[index]}
                                plan_config_index={configurationIndex}
                                PLAN_CONFIGURATION={PLAN_CONFIGURATION}
                            />
                        </motion.div>
                    </AnimatePresence>

                    {/*Plan slider*/}
                    <div
                        style={
                            !PaymnetStore.isPaymentSelected
                                ? {
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "16px",
                                    width: "100%",
                                    flex: 1,
                                    overflow: "auto"
                                }
                                : {display: "none"}
                        }
                    >
                        <div className="vpn__button_slider">
                            {PLAN_NAMES.map((plan) => (
                                <SliderBtn
                                    currentIndex={index}
                                    setCurrentIndex={setIndex}
                                    sliderIndex={plan.id}
                                    text={plan.text}
                                />
                            ))}
                        </div>
                        <div className="vpn__button_slider">
                            {PLAN_CONFIGURATION.map((plan, index) => (
                                <SliderBtn
                                    key={index}
                                    currentIndex={configurationIndex}
                                    setCurrentIndex={setConfigurationIndex}
                                    sliderIndex={plan.id}
                                    text={plan.name}
                                    icon={plan.icon}
                                />
                            ))}
                        </div>
                        <motion.div
                            key={configurationIndex}
                            className={style.vpn_card__main__second_block}
                            initial={{opacity: 0}}
                            animate={{opacity: 1}}
                            transition={{duration: 0.3}}
                        >
                            {plan_data[index].plan_features[configurationIndex].map(
                                (el, index) => (
                                    <motion.div
                                        key={index}
                                        layout
                                        initial={{opacity: 0, x: -20}}
                                        animate={{opacity: 1, x: 0}}
                                        transition={{
                                            duration: 0.3,
                                            delay: index * 0.1,
                                            layout: {duration: 0}
                                        }}
                                        style={{
                                            willChange: "transform, opacity",
                                            transform: "translateZ(0)",
                                            backfaceVisibility: "hidden",
                                            WebkitTransform: 'translate3d(0,0,0)'
                                        }}
                                        className={`${style.vpn_card__main__second_block__item} second_block_item`}
                                    >
                                        <div style={{
                                            display: "flex",
                                            gap: "10px",
                                        }}>
                                            <img
                                                style={{
                                                    borderRadius: 4,
                                                    border: "1px solid #424446",
                                                    background: "#2D2F31",
                                                    padding: 9,
                                                    width: 38,
                                                    height: 38,
                                                }}
                                                src={el[0]}
                                                alt={`Feature ${index + 1}`}
                                            />
                                            <div
                                                className={style.vpn_card__main__second_block__item__text}
                                            >
                                                <p>{el[1]}</p>
                                                <p>{el[2]}</p>
                                                {el[3] && activeTooltip === index && (
                                                    <div className={style.tooltip} ref={tooltipRef}>
                                                        <span
                                                            className={`${style.tooltipText} ${isHiding ? style.hiding : ''}`}>{el[3]}</span>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        {el[3] && (
                                            <button onClick={() => handleTooltipClick(index, el)}>
                                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none"
                                                     xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M8.25 12.75H9.75V8.25H8.25V12.75ZM9 6.75C9.2125 6.75 9.39075 6.678 9.53475 6.534C9.67875 6.39 9.7505 6.212 9.75 6C9.7495 5.788 9.6775 5.61 9.534 5.466C9.3905 5.322 9.2125 5.25 9 5.25C8.7875 5.25 8.6095 5.322 8.466 5.466C8.3225 5.61 8.2505 5.788 8.25 6C8.2495 6.212 8.3215 6.39025 8.466 6.53475C8.6105 6.67925 8.7885 6.751 9 6.75ZM9 16.5C7.9625 16.5 6.9875 16.303 6.075 15.909C5.1625 15.515 4.36875 14.9808 3.69375 14.3063C3.01875 13.6318 2.4845 12.838 2.091 11.925C1.6975 11.012 1.5005 10.037 1.5 9C1.4995 7.963 1.6965 6.988 2.091 6.075C2.4855 5.162 3.01975 4.36825 3.69375 3.69375C4.36775 3.01925 5.1615 2.485 6.075 2.091C6.9885 1.697 7.9635 1.5 9 1.5C10.0365 1.5 11.0115 1.697 11.925 2.091C12.8385 2.485 13.6323 3.01925 14.3063 3.69375C14.9803 4.36825 15.5148 5.162 15.9098 6.075C16.3048 6.988 16.5015 7.963 16.5 9C16.4985 10.037 16.3015 11.012 15.909 11.925C15.5165 12.838 14.9823 13.6318 14.3063 14.3063C13.6303 14.9808 12.8365 15.5152 11.925 15.9097C11.0135 16.3042 10.0385 16.501 9 16.5ZM9 15C10.675 15 12.0938 14.4187 13.2563 13.2562C14.4188 12.0937 15 10.675 15 9C15 7.325 14.4188 5.90625 13.2563 4.74375C12.0938 3.58125 10.675 3 9 3C7.325 3 5.90625 3.58125 4.74375 4.74375C3.58125 5.90625 3 7.325 3 9C3 10.675 3.58125 12.0937 4.74375 13.2562C5.90625 14.4187 7.325 15 9 15Z"
                                                        fill="white"/>
                                                </svg>
                                            </button>
                                        )}
                                    </motion.div>
                                )
                            )}
                        </motion.div>
                    </div>
                </div>
                {/*Payments components*/}
                {PaymnetStore.isPaymentSelected && paymentsMethods && (
                    <Payments paymentsItem={paymentsMethods}/>
                )}
                {/*{(PaymnetStore.paymentMethod === 1 || PaymnetStore.paymentMethod === 2 || PaymnetStore.paymentMethod === 5) &&*/}
                {/*    <EmailInput/>}*/}
            </div>

            {/*Главная кнопка покупки*/}
            <motion.button
                whileHover={{scale: 1.03}}
                whileTap={{scale: 0.95}}
                disabled={PaymnetStore.isPaymentProcessed}
                className="vpn__button_buy_plan_btn"
                onClick={() => {
                    PaymnetStore.setIsPaymentSelected(true);
                    hapticFeedBack();

                    if (PaymnetStore.isPaymentSelected && PaymentStore.paymentMethod) {
                        PaymnetStore.setPaymentProcessed(true);
                        paymentMethodHandler();
                    }
                }}
            >
                {PaymnetStore.isPaymentProcessed ? (
                    <IosLoader/>
                ) : (
                    <p
                        style={{
                            fontSize: "16px",
                            fontFamily: "VK Sans Display",
                            fontWeight: "500",
                            lineHeight: "140%",
                        }}
                    >
                        {" "}
                        {PaymnetStore.paymentMethod
                            ? lang_code === "ru"
                                ? `Оплатить с ${
                                    paymentsMethods.find(
                                        (el) => el.id === PaymnetStore.paymentMethod
                                    )?.name || ""
                                }`
                                : `Pay with ${
                                    paymentsMethods.find(
                                        (el) => el.id === PaymnetStore.paymentMethod
                                    )?.name || ""
                                }`
                            : PaymnetStore.isPaymentSelected
                                ? lang_code === "ru"
                                    ? "Выберте способ оплаты"
                                    : "Select payment method"
                                : lang_code === "ru"
                                    ? "Купить"
                                    : "Pay"}
                    </p>
                )}
            </motion.button>
        </>
    );
});
